import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

/**
 * ============================================================================
 * Compact Theme Toggle - Simple Sun/Moon Switch
 * ============================================================================
 * Industry Standard: Single button toggle for light/dark mode
 * Used by: GitHub, Twitter, YouTube, Discord
 * Behavior: Click to toggle between light and dark mode
 * ============================================================================
 */
const ThemeToggle: React.FC = () => {
  const { theme, setTheme, resolvedTheme } = useTheme();

  const handleToggle = () => {
    // If explicitly set to light/dark, toggle between them
    // If set to 'system', switch to opposite of current resolved theme
    if (theme === 'system') {
      setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
    } else {
      setTheme(theme === 'dark' ? 'light' : 'dark');
    }
  };

  return (
    <button
      onClick={handleToggle}
      className="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-all duration-200 group"
      title={resolvedTheme === 'dark' ? "Switch to light mode" : "Switch to dark mode"}
      aria-label={resolvedTheme === 'dark' ? "Switch to light mode" : "Switch to dark mode"}
    >
      {resolvedTheme === 'dark' ? (
        <Moon className="h-4 w-4 text-indigo-500 dark:text-indigo-400 group-hover:text-indigo-600 dark:group-hover:text-indigo-300 transition-colors" />
      ) : (
        <Sun className="h-4 w-4 text-amber-500 group-hover:text-amber-600 transition-colors" />
      )}
    </button>
  );
};

export default ThemeToggle;

